import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '../db/supabase.types.ts'
import { createParsedAddress, createParsedAddresses } from './types.ts'

export async function getAddressById(
  addressId: string,
  ctx: { supabase: SupabaseClient<Database> }
) {
  const { data, error } = await ctx.supabase
    .from('addresses')
    .select('*, address_connections(*)')
    .eq('id', addressId)
    .maybeSingle()

  if (error || !data) {
    console.error('Error fetching address by id:', error)
    return null
  }

  return createParsedAddress(data)
}

// Get all addresses
export async function getAddresses(ctx: { supabase: SupabaseClient<Database> }) {
  const { data, error } = await ctx.supabase.from('addresses').select('*, address_connections(*)')

  if (error) {
    console.error('Error fetching addresses:', error)
    return []
  }

  return createParsedAddresses(data || [])
}

// Get addresses by postal code
export async function getPostalCodeAddresses(
  postalCode: string,
  ctx: { supabase: SupabaseClient<Database> }
) {
  const { data, error } = await ctx.supabase
    .from('addresses')
    .select('*, address_connections(*)')
    .eq('postal_code', postalCode)

  if (error) {
    console.error('Error fetching addresses by postal code:', error)
    return []
  }

  return createParsedAddresses(data || [])
}
